export const RequestStatus = {
    NONE: '$#none',
    ACTIVE: '$#active',
    SUCCESS: '$#success',
    FAIL: '$#fail',
    REJECTED: '$#rejected',
    FORBIDDEN: '$#forbidden',
    UNAUTHORIZED: '$#unauthorized',
}